function GuidelinesController(clickCallback) {

	//setup the FAQ buttons
	$('.faq a').each( function(i) {
		$(this).on('click', function() {

			//_gaq.push(['_trackEvent', 'GuidelinesPrizes', 'FAQ', 'Toggle', i ]);
      ga('send', 'event', 'GuidelinesPrizes', 'FAQ', 'Toggle', i );

			//CLOSE THE OTHERS FIRST
			$('.faq a').each( function(k) {
				if( $($(this).next()).is( ":visible" ) && i != k ) { $($(this).next()).slideUp(200);$(this).parent().parent().removeClass('open'); }
			});


			$($(this).next()).slideToggle(200, function() { $('.faq').addClass('z').removeClass('z'); }); //IE8 HACK to get the page to redraw

			if( $(this).parent().parent().hasClass('open') ) {
				$(this).parent().parent().removeClass('open');
			} else {
				$(this).parent().parent().addClass('open');
			}


		});
	});




	$(window).scroll( $.proxy(this.handleScroll, this) );

}

module.exports = GuidelinesController;



// WEBPACK FOOTER //
// ./js/src/GuidelinesController.js